export default function SectionTitle({ children }: { children: React.ReactNode }) {
  return (
    <div className="mb-8">
      <h2
        className="text-2xl md:text-3xl font-black gradient-text mb-2"
        style={{ fontFamily: "'Cinzel', serif" }}
      >
        {children}
      </h2>
      <div className="section-divider w-32"></div>
    </div>
  );
}
